import styled from 'styled-components';

export const TimeLineCardContainer = styled.div`
  .TimeLineCard {
    background: #ffffff;
    border-radius: 0.25rem;
    margin-top: 1.5rem;
  }
`;
